<template>
  <div class="sso-overlay">
    <div class="sso-loader">
      <div class="sso-spinner"></div>

      <div v-if="error" class="sso-error">
        <p class="sso-error-text">{{ error }}</p>
        <button class="sso-error-btn" @click="goToLogin">Ir para Login</button>
      </div>

      <p v-else class="sso-status-text">Conectando ao evento...</p>
    </div>
  </div>
</template>

<script>
import { ssoAuthenticate } from '../services'

export default {
  name: 'SsoAuth',
  data () {
    return {
      error: null
    }
  },
  async mounted () {
    const token = this.$route.query.token
    const returnUrl = this.$route.query.return_url

    if (!token) {
      this.$router.replace({ name: 'login' })
      return
    }

    try {
      const response = await ssoAuthenticate({ token })
      const accessToken = response.data.access_token
      const { user } = response.data

      await this.$store.dispatch('auth/ActionSetToken', accessToken)
      await this.$store.dispatch('auth/ActionSetUser', user.data)

      if (returnUrl) {
        localStorage.setItem('sso_return_url', decodeURIComponent(returnUrl))
      }
      localStorage.setItem('sso_origin', 'master_panel')

      this.$router.replace({ name: 'home' })
    } catch (err) {
      console.error('SSO authentication failed:', err)
      this.error = err?.response?.data?.message || 'Falha na autenticação SSO. O token pode ter expirado.'
    }
  },
  methods: {
    goToLogin () {
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>

<style scoped>
.sso-overlay {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.sso-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sso-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e5e7eb;
  border-top-color: #3b82f6;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-bottom: 24px;
}
.sso-status-text {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
}
.sso-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
.sso-error-text {
  font-size: 14px;
  color: #ef4444;
  text-align: center;
  max-width: 300px;
}
.sso-error-btn {
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  background: #3b82f6;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
.sso-error-btn:hover { background: #2563eb; }

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>
